import React, { useRef, useEffect, useState } from 'react'
import { useConfig } from '../Utils/ConfigContext'
import '@/styles/globals.css'
import '../../style.css'
import { keyframes } from '@emotion/react'
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  IconButton,
  InputAdornment,
  useTheme,
  Stack,
  Drawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import MenuIcon from '@mui/icons-material/Menu'
import { PopupModal } from './PopupModal'

  const links = {
    'symbol': 'https://app.reciation.org/index.php/the-significance-of-the-wao-signet-unveiling-the-hidden-meanings/',
    'whitepaper': 'https://app.reciation.org/index.php/the-wao-whitepaper-2/',
    'organization': 'https://app.reciation.org/index.php/organization/'
  }

const SearchInterfaceComponent = ({ onCoinSelected, refreshGlobeData, onCoinLocationFound }) => {
  const modalRef = useRef(null)
  const lightboxAppear = keyframes`
    from {
      opacity: 0;
      transform: translate(-50%, -55%) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  `
  const searchInputRef = useRef(null)
  const mobileSearchInputRef = useRef(null)
  const config = useConfig()
  const theme = useTheme()
  const [showCoinInfo, setShowCoinInfo] = useState(false)
  const [activeSection, setActiveSection] = useState('code')
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [topCoins, setTopCoins] = useState([])
  const [loadingTopCoins, setLoadingTopCoins] = useState(false)

  useEffect(() => {
    fetchTopCoins()
    return () => {
    }
  }, [])
  
  const fetchTopCoins = async () => {
    setLoadingTopCoins(true)
    try {
      const response = await fetch(config.getApiUrl('/api/top_coins'))
      const data = await response.json()
      if (data.success) {
        setTopCoins(data.coins || [])
      }
    } catch (error) {
      console.error('Error fetching top coins:', error)
    } finally {
      setLoadingTopCoins(false)
    }
  }

  useEffect(() => {
    if (showCoinInfo) {
      setMobileMenuOpen(false)
    }
  }, [showCoinInfo])

  const searchCoin = (coinId) => {
    if (!coinId) return

    if (modalRef.current) {
      modalRef.current.searchCoin(coinId)
    }
  }
  
  const searchCoinById = (coinId) => {
    if (!coinId) return
    
    if (modalRef.current) {
      modalRef.current.searchCoinById(coinId)
    }
  }


  const handleSearch = (fromMobile = false) => {
    const inputRef = fromMobile ? mobileSearchInputRef : searchInputRef

    if (inputRef.current) {
      const coinId = inputRef.current.value.trim()
      if (coinId) {

        searchCoin(coinId)
        if (fromMobile) {
          setMobileMenuOpen(false)
        }
      }
    }
  }

  const handleKeyPress = (event, fromMobile = false) => {
    if (event.key === 'Enter') {
      handleSearch(fromMobile)
    }
  }

  const handleClose = () => {

    if (searchInputRef.current) {
      searchInputRef.current.value = ''
    }

    setShowCoinInfo(false)


    if (onCoinSelected && typeof onCoinSelected === 'function') {
    }
  }


  return (
    <Box sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      pointerEvents: 'none',
      zIndex: 100,
      overflow: 'hidden'
    }}>
      {/* Mobile Burger Menu Button */}
      <Box
        sx={{
          position: 'absolute',
          top: 16,
          left: 16,
          zIndex: 1001,
          display: { xs: 'block', sm: 'none' },
          pointerEvents: 'auto'
        }}
      >
        <IconButton
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          sx={{
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: 'white',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.9)'
            }
          }}
        >
          <MenuIcon />
        </IconButton>
      </Box>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': {
            width: 280,
            backgroundColor: 'rgba(0, 0, 0, 0.95)',
            backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.03) 1px, transparent 1px)',
            backgroundSize: '15px 15px',
            border: 'none'
          }
        }}
      >
        <Box sx={{ p: 2, pb: 4 }}>
          <Box
            sx={{
              borderRadius: 1,
              overflow: 'hidden',
              background: 'linear-gradient(135deg, #f5756c 0%, #f76863 50%, #f9b949 100%)',
              textAlign: 'center',
              p: 1,
              mb: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: 'white',
                fontWeight: 'bold',
                textShadow: '0px 1px 2px rgba(0,0,0,0.3)',
              }}
            >
              COIN-CODE
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <TextField
              inputRef={mobileSearchInputRef}
              placeholder="Enter code"
              variant="outlined"
              fullWidth
              size="small"
              onKeyPress={(e) => handleKeyPress(e, true)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => handleSearch(true)} edge="end" sx={{ color: 'white' }}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: 1,
                  color: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(255, 255, 255, 0.5)',
                  },
                }
              }}
            />
          </Box>

          <Typography
            variant="caption"
            sx={{
              color: 'rgba(255, 255, 255, 0.8)',
              display: 'block',
              lineHeight: 1.4,
              fontSize: '0.7rem',
              textAlign: 'center',
              textTransform: 'uppercase',

              mb: 3,
            }}
          >
            Each coin carries a unique code. When someone receives one, they can log its location on this website. Over time, this builds a global network of travelling appreciation for one another.
          </Typography>

          <Stack spacing={1.5}>
            <Button
              variant="text"
              onClick={() => window.open(links.symbol, '_blank')}
              sx={{
                color: 'white',
                justifyContent: 'center',
                textAlign: 'left',
                fontSize: '0.8rem',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              THE SYMBOL
            </Button>

            <Button
              variant="text"
              onClick={() => window.open(links.whitepaper, '_blank')}
              sx={{
                color: 'white',
                justifyContent: 'center',
                textAlign: 'left',
                fontSize: '0.8rem',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              WHITEPAPER
            </Button>

            <Button
              variant="text"
              onClick={() => window.open(links.organization, '_blank')}
              sx={{
                color: 'white',
                justifyContent: 'center',
                textAlign: 'left',
                fontSize: '0.8rem',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              ORGANIZATION
            </Button>
               
            <Box sx={{ mt: 4 }}>
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  textShadow: '0px 1px 2px rgba(0,0,0,0.3)',
                  mb: 2,
                  fontSize: '0.9rem',
                  textAlign: 'center'
                }}
              >
                MOST TRAVELLED COINS
              </Typography>
              
              <TableContainer 
                component={Paper}
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, 0.2)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: 1,
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  maxHeight: 200,
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '3px',
                  }
                }}
              >
                <Table size="small" aria-label="top coins table">
                  <TableHead>
                    <TableRow>
                      <TableCell 
                        sx={{ 
                          color: 'rgba(255, 255, 255, 0.7)', 
                          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                          padding: '8px 16px',
                          fontSize: '0.7rem'
                        }}
                      >
                        COIN
                      </TableCell>
                      <TableCell 
                        align="right" 
                        sx={{ 
                          color: 'rgba(255, 255, 255, 0.7)', 
                          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                          padding: '8px 16px',
                          fontSize: '0.7rem'
                        }}
                      >
                        LOGS
                      </TableCell>
                      <TableCell 
                        align="right" 
                        sx={{ 
                          color: 'rgba(255, 255, 255, 0.7)', 
                          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                          padding: '8px 16px',
                          fontSize: '0.7rem'
                        }}
                      >
                        DISTANCE
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingTopCoins ? (
                      <TableRow>
                        <TableCell 
                          colSpan={3} 
                          align="center"
                          sx={{ 
                            color: 'white', 
                            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                            padding: '12px 16px'
                          }}
                        >
                          Loading...
                        </TableCell>
                      </TableRow>
                    ) : topCoins.length > 0 ? (
                      topCoins.map((coin) => (
                        <TableRow
                          key={coin.coinid}
                          sx={{ 
                            '&:hover': { 
                              backgroundColor: 'rgba(255, 255, 255, 0.05)' 
                            },
                            cursor: 'pointer'
                          }}
                          onClick={() => searchCoinById(coin.coinid)}
                        >
                          <TableCell 
                            component="th" 
                            scope="row"
                            sx={{ 
                              color: 'white', 
                              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                              padding: '8px 16px',
                              fontSize: '0.75rem'
                            }}
                          >
                            Coin {coin.formattedCoinId}
                          </TableCell>
                          <TableCell 
                            align="right"
                            sx={{ 
                              color: 'white', 
                              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                              padding: '8px 16px',
                              fontSize: '0.75rem'
                            }}
                          >
                            Logs {coin.logs}
                          </TableCell>
                          <TableCell 
                            align="right"
                            sx={{ 
                              color: 'white', 
                              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                              padding: '8px 16px',
                              fontSize: '0.75rem'
                            }}
                          >
                            {coin.distance} km
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell 
                          colSpan={3} 
                          align="center"
                          sx={{ 
                            color: 'white', 
                            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                            padding: '12px 16px',
                            fontSize: '0.75rem'
                          }}
                        >
                          No data available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Stack>
        </Box>
      </Drawer>

      {/* Desktop Side Panel */}
      <Box sx={{
        position: 'absolute',
        top: 24,
        left: 24,
        maxWidth: 500,
        width: 300,
        zIndex: 1000,
        pointerEvents: 'auto',
        display: { xs: 'none', sm: 'block' }
      }}>
        <Paper
          elevation={3}
          sx={{
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            borderRadius: 1,
            overflow: 'hidden',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            position: 'relative',
            backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.03) 1px, transparent 1px)',
            backgroundSize: '15px 15px',
          }}
        >
          <Box sx={{
            p: 2,
            pb: 4,
          }}>
            <Box
              sx={{
                borderRadius: 1,
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #f5756c 0%, #f76863 50%, #f9b949 100%)',
                textAlign: 'center',
                p: 1,
                mb: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  textShadow: '0px 1px 2px rgba(0,0,0,0.3)',
                }}
              >
                COIN-CODE
              </Typography>
            </Box>

            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <TextField
                inputRef={searchInputRef}
                placeholder="Enter code"
                variant="outlined"
                fullWidth
                size="small"
                onKeyPress={handleKeyPress}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={(e) => handleSearch(false)} edge="end" sx={{ color: 'white' }}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: 1,
                    color: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(255, 255, 255, 0.3)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(255, 255, 255, 0.5)',
                    },
                  }
                }}
              />
            </Box>

            <Typography
              variant="caption"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                display: 'block',
                lineHeight: 1.4,
                fontSize: '0.7rem',
                textAlign: 'center',
                textTransform: 'uppercase',
                mb: 3,
              }}
            >
              Each coin carries a unique code. When someone receives one, they can log its location on this website. Over time, this builds a global network of travelling appreciation for one another.
            </Typography>

            <Stack spacing={1.5}>
              <Button
                onClick={() => window.open(links.symbol, '_blank')}
                variant="text"
                sx={{
                  color: 'white',
                  justifyContent: 'center',
                  textAlign: 'left',
                  fontSize: '0.8rem',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                  }
                }}
              >
                THE SYMBOL
              </Button>

              <Button
                variant="text"
                onClick={() => window.open(links.whitepaper, '_blank')}
                sx={{
                  color: 'white',
                  justifyContent: 'center',
                  textAlign: 'left',
                  fontSize: '0.8rem',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                  }
                }}
              >
                WHITEPAPER
              </Button>

              <Button
                variant="text"
                onClick={() => window.open(links.organization, '_blank')}
                sx={{
                  color: 'white',
                  justifyContent: 'center',
                  textAlign: 'left',
                  fontSize: '0.8rem',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                  }
                }}
              >
                ORGANIZATION
              </Button>
            </Stack>
            
            <Box sx={{ mt: 4 }}>
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  textShadow: '0px 1px 2px rgba(0,0,0,0.3)',
                  mb: 2,
                  fontSize: '0.9rem',
                  textAlign: 'center'
                }}
              >
                MOST TRAVELLED COINS
              </Typography>
              
              <TableContainer 
                component={Paper}
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, 0.2)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: 1,
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  maxHeight: 200,
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '3px',
                  }
                }}
              >
                <Table size="small" aria-label="top coins table">
                  <TableHead>
                    <TableRow>
                      <TableCell 
                        sx={{ 
                          color: 'rgba(255, 255, 255, 0.7)', 
                          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                          padding: '8px 16px',
                          fontSize: '0.7rem'
                        }}
                      >
                        COIN
                      </TableCell>
                      <TableCell 
                        align="right" 
                        sx={{ 
                          color: 'rgba(255, 255, 255, 0.7)', 
                          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                          padding: '8px 16px',
                          fontSize: '0.7rem'
                        }}
                      >
                        LOGS
                      </TableCell>
                      <TableCell 
                        align="right" 
                        sx={{ 
                          color: 'rgba(255, 255, 255, 0.7)', 
                          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                          padding: '8px 16px',
                          fontSize: '0.7rem'
                        }}
                      >
                        DISTANCE
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingTopCoins ? (
                      <TableRow>
                        <TableCell 
                          colSpan={3} 
                          align="center"
                          sx={{ 
                            color: 'white', 
                            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                            padding: '12px 16px'
                          }}
                        >
                          Loading...
                        </TableCell>
                      </TableRow>
                    ) : topCoins.length > 0 ? (
                      topCoins.map((coin) => (
                        <TableRow
                          key={coin.coinid}
                          sx={{ 
                            '&:hover': { 
                              backgroundColor: 'rgba(255, 255, 255, 0.05)' 
                            },
                            cursor: 'pointer'
                          }}
                          onClick={() => searchCoinById(coin.coinid)}
                        >
                          <TableCell 
                            component="th" 
                            scope="row"
                            sx={{ 
                              color: 'white', 
                              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                              padding: '8px 16px',
                              fontSize: '0.75rem'
                            }}
                          >
                            Coin {coin.formattedCoinId}
                          </TableCell>
                          <TableCell 
                            align="right"
                            sx={{ 
                              color: 'white', 
                              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                              padding: '8px 16px',
                              fontSize: '0.75rem'
                            }}
                          >
                            Logs {coin.logs}
                          </TableCell>
                          <TableCell 
                            align="right"
                            sx={{ 
                              color: 'white', 
                              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                              padding: '8px 16px',
                              fontSize: '0.75rem'
                            }}
                          >
                            {coin.distance} km
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell 
                          colSpan={3} 
                          align="center"
                          sx={{ 
                            color: 'white', 
                            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                            padding: '12px 16px',
                            fontSize: '0.75rem'
                          }}
                        >
                          No data available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Paper>


      </Box>
      <PopupModal
        ref={modalRef}
        showCoinInfo={showCoinInfo}
        onCoinSelected={onCoinSelected}
        refreshGlobeData={refreshGlobeData}
        onCoinLocationFound={onCoinLocationFound}
        onClose={handleClose}
      />
    </Box>
  )
}

export default SearchInterfaceComponent
